import Documents from "./page";

export default Documents;
